import { gql } from '@apollo/client';
import { articleCommonData } from './articleCommonData';

const getArticleDataById = gql`
  query getArticleDataById($articleId: ID) {
    article(where: { id: $articleId }) {
      ${articleCommonData}
    }
  }
`;
export default getArticleDataById;
